export const AUTO_REPLY_LABEL = 'auto-reply'
export const WITHDRAWN_COMMENT_PLACEHOLDER = 'This message was unsent.'

export function commentIsAutoReply(comment: object | null | undefined): boolean {
  if (!comment || !('isAutoReply' in comment)) {
    return false
  }
  return Boolean((comment as { isAutoReply?: boolean }).isAutoReply)
}

export function commentWithdrawnAt(comment: object | null | undefined): string | null {
  if (!comment || !('withdrawnAt' in comment)) {
    return null
  }
  const value = (comment as { withdrawnAt?: string | null }).withdrawnAt
  return value || null
}

/**
 * The quiet "auto-reply" label: shown to every viewer on a message the system sent on its own
 * (`originKey === 'system'`), including follow-on messages. A hand send-as has no label, and an
 * unsent message shows only its placeholder.
 */
export function commentShowsAutoReplyLabel(comment: object | null | undefined): boolean {
  if (!comment || !('originKey' in comment) || commentWithdrawnAt(comment)) {
    return false
  }
  return (comment as { originKey?: string | null }).originKey === 'system'
}

export type LiveCommentFields = {
  id?: string
  commentId?: string
  body?: string | null
  embedsAsJson?: unknown
  createdAt?: string | null
  deletedAt?: string | null
  withdrawnAt?: string | null
  thinking?: unknown
}

/**
 * What the live subscription writes into the cache (`ScoCommentLivePatch` in ChatMessageList).
 * `withdrawnAt` rides along so an open chat redraws a recalled message as the placeholder.
 */
export function liveCommentPatchData(live: LiveCommentFields) {
  return {
    __typename: 'ScoComment' as const,
    id: live.id,
    commentId: live.commentId,
    body: live.body,
    embedsAsJson: live.embedsAsJson,
    createdAt: live.createdAt,
    deletedAt: live.deletedAt,
    withdrawnAt: live.withdrawnAt ?? null,
    thinking: live.thinking ?? null,
  }
}
